import { render, staticRenderFns } from "./RentalClothesFooter.vue?vue&type=template&id=394f3f78&"
import script from "./RentalClothesFooter.vue?vue&type=script&lang=js&"
export * from "./RentalClothesFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports